import { getBackendURLForResources } from '../utils/utils';

export const uploadImage = async file => {
  const data = new FormData();
  data.append('file', file);
  data.append('upload_preset', 'digi-card');
  data.append('cloud_name', 'digi-card');

  const response = await fetch(`${getBackendURLForResources()}/upload`, {
    method: 'POST',
    body: data,
    credentials: 'include',
  });
  return response.json();
};
